module.exports = __webpack_public_path__ + "static/img/1.80150b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgaofu/1.png
// module id = GKl1
// module chunks = 0